var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GeneralView',[_c('LoginView',{staticClass:"view",attrs:{"slot":"default","full-view":false,"price-list":_vm.priceList},slot:"default"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }